
import { Injectable } from '@angular/core';
import {
    HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent
} from '@angular/common/http';

import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/do';

import { TokenService } from './core/auth';
import { AuthUser } from './core/auth/auth-user';
import { AuthService } from './core/auth/auth.service';

const TOKEN_HEADER_KEY = 'Authorization';
const TOKEN_HEADER_PREFIX = 'Bearer ';

@Injectable()
export class Interceptor implements HttpInterceptor {

    authUser: AuthUser = this.token.whoAmI();

    constructor(
        private router: Router,
        private token: TokenService,
        private authService: AuthService
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.token.hasToken()) {
            this.router.navigate(['/']);
        }
        const request = this.addToken(req);
        this.token.setAccess();
        return next.handle(request).do(
            (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401) {
                        this.token.signOut();
                        this.router.navigate(['/']);
                    }
                }
            }
        );
    }

    addToken(req: HttpRequest<any>): HttpRequest<any> {
        const token = this.token.getToken();
        if (token != null) {
            return req.clone(
                { headers: req.headers.set(TOKEN_HEADER_KEY, TOKEN_HEADER_PREFIX + token) }
            );
        }
        return req;
    }

    checkExpire() {
        this.authUser = this.token.whoAmI();
        if (this.authUser.doTokenExpiresWithinMinutes(5)) {
            this.authService.refresh().subscribe((data) => { this.token.saveToken(data.token); });
        }
    }

}
